import { ApiUrl } from "../../../Constants/Api";
import {
  REQUEST_METHOD,
  WebService,
} from "../../WebServiceManager/RequestService";
import AdminPreferencesRequestBody from "./AdminPrefrencesRequestBody";

export default class AdminPreferenceService {
  request = new AdminPreferencesRequestBody();
  static shared = new AdminPreferenceService();

  AdminPreferenceRequest = (payload) => {
    return new Promise((resolve, reject) => {
      WebService.clientShared
        .callServiceApi(
          ApiUrl.addAdminprefrence(),
          this.request.AdminPreferencesRequest(payload, REQUEST_METHOD.POST)
        )
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  AdminPreferenceListRequest = (payload) => {
    return new Promise((resolve, reject) => {
      WebService.clientShared
        .callServiceApi(
          ApiUrl.getAdminprefrence(payload),
          this.request.AdminPreferencesListRequest(REQUEST_METHOD.GET)
        )
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  AdminPreferenceByIdRequest = (payload) => {
    return new Promise((resolve, reject) => {
       WebService.clientShared
       .callServiceApi(
        ApiUrl.getAdminprefrenceByName(payload),
        this.request.AdminPreferencesByIdRequest(REQUEST_METHOD.GET)
      )
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
        });
        });
        };

        EditAdminPreference =(payload) =>{
          return new Promise((resolve,reject) =>{
            WebService.clientShared
            .callServiceApi(
              ApiUrl.editAdminPreference(payload.companyName),
              this.request.EditAdminPreference(REQUEST_METHOD.PUT, payload.data)
            )
            .then((response) =>{
              resolve(response)
            })
            .catch((error)=>{
              reject(error)
            })
          })
        }
}
